export const USER_AUTH = '/api/v1/user/auth';
export const USER_SIGNIN = '/api/v1/user/signIn';
export const USER_GRANT_ACCESS = '/api/v1/user/grantAccess';

export const PLANS = '/private/v2/plans';
export const PLANS_ORDER = '/private/v2/plans/weights';

export const NEW_HOLIDAY_SETTING = '/private/v1/setting/newHolidaySetting';
export const HOLIDAYS = '/private/v1/setting/holiday';
